module.exports = __webpack_public_path__ + "img/45.320ed200.jpg";